import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Wrapper from "../components/Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { lang, menu, shortFunction, sip, moneyT } from "../translate";
import Paper from "@mui/material/Paper";
import { Box, CircularProgress, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Api from "../Api";
import EditShortFunction from "../components/EditShortFunction";
import ShortInfoCard from "../components/ShortInfoCard";
import SipOperators from "../components/new_component/SipOperators";
import OpenAi from '../components/new_component/OpenAi';
import { useLocation, useNavigate } from 'react-router-dom';
import Telecomunication from '../components/new_component/Telecomunication';
import BlockedComponent from '../components/new_component/BlockedComponent';
import { hasReportView } from '../helpers/employeePermissions';

const { REACT_APP_SERVER } = process.env;
const color = REACT_APP_SERVER === 'ATS' ? '#0b73b9' : '#7ebc0a';

function ShortFunction(props) {
    const [edit, setEdit] = useState(0)
    const [have, setHave] = useState(false)
    const [translate, setTranslate] = useState([])
    const [loading, setLoading] = useState(false)
    const userData = useSelector((state) => state.users.userData)
    const employeeData = useSelector((state) => state.users.employeeData)
    const [short, setShort] = useState([{ member: userData.id, function_code: 10999, day_count: 3 },
    { member: userData.id, function_code: 10888, day_count: 3 },
    { member: userData.id, function_code: 100097, day_count: 3 }])
    const [operatorCounts, setOperatorCounts] = useState({ isSpeech: 0, sendMail: 0 })
    const [speechList, setSpeechList] = useState([])
    const [clickToCallIps, setClickToCallIps] = useState([]);
    const [musicHoldFiles, setMusicHoldFiles] = useState([]);
    const [callCenter, setCallCenter] = useState(null);
    const [preCallAnnouncement, setPreCallAnnouncement] = useState(null);
    const [callbackActive, setCallbackActive] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    useEffect(() => {
        (async () => {
            setLoading(true)
            try {
                const { data } = await Api.shortFunctionGet()
                const translates = await Api.shortFunctionGetList()
                setTranslate(translates.data.data)
                const { data: ipData } = await Api.getIp()
                const ipsFromApi = Array.isArray(ipData?.data)
                    ? ipData.data.map(item => item.ip).filter(Boolean)
                    : [];
                setClickToCallIps(ipsFromApi)

                const { data: filesData } = await Api.fileGet()
                const musicHoldFilesList = Array.isArray(filesData?.file)
                    ? filesData.file.filter(file => file.mhold === 1)
                    : [];
                setMusicHoldFiles(musicHoldFilesList)
                const { data: callbackResponse } = await Api.getCallback()
                setCallbackActive(!!callbackResponse?.data)
                const { data: preCallAnnouncementData } = await Api.getPreCallAnnouncement()
                setPreCallAnnouncement(preCallAnnouncementData?.file?.length > 0 ? true : false)
                const baseList = [
                    { member: userData.id, function_code: 10999, day_count: 3, status: 0 },
                    { member: userData.id, function_code: 10888, day_count: 3, status: 1 }, // always active
                    { member: userData.id, function_code: 100097, day_count: 3, status: 0 }
                ];

                if (!data.data.length) {
                    setShort(baseList)
                } else {
                    setHave(true)
                    const merged = baseList.map(b => {
                        const found = data.data.find(d => +d.function_code === +b.function_code)
                        const statusOverride = +b.function_code === 10888 ? 1 : (found?.status ?? b.status ?? 0);
                        return found ? { ...b, ...found, status: statusOverride } : { ...b, status: statusOverride }
                    })
                    setShort(merged)
                }
            } catch (e) {
                console.log(e)
            } finally {
                setLoading(false)
            }
        })()
    }, [userData?.id, location.key])

    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.shortOperatorCounts()
                setOperatorCounts(data.count)
            } catch (e) {
                setOperatorCounts({ isSpeech: 0, sendMail: 0 })
                console.log(e)
            }
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.callCenterGet()
                setCallCenter(data.callCenter)
            } catch (e) {
                setCallCenter(null)
                console.log(e)
            }
        })()
    }, [])




    const operatorLabel = useMemo(() => shortFunction.operator?.[+localStorage.getItem('atsLang') || 1], []);

    const fetchSpeech = useCallback(async () => {
        try {
            const { data } = await Api.shortSipList();
            const list = data?.data || [];
            setSpeechList(list);
        } catch (e) {
            console.log(e)
            setSpeechList([]);
        }
    }, []);

    useEffect(() => {
        if (!speechList.length) {
            fetchSpeech();
        }
    }, [fetchSpeech, speechList.length]);

    const operatorCountLabel = `(${operatorCounts?.sendMail ?? 0})`;

    return (
        <>
            <Helmet>
                <title>
                    {menu.shortF[+localStorage.getItem('atsLang') || 1]}
                </title>
            </Helmet>
            <Wrapper>
                <div className={`tableParent ${REACT_APP_SERVER === 'ATS' ? 'ats-theme' : ''}`} style={{ padding: 20 }}>
                    {loading ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '400px',
                            }}
                        >
                            <CircularProgress sx={{ color: '#7ebc0a' }} />
                        </Box>
                    ) : (
                        <>
                            <Typography sx={{ fontWeight: 700, m: 0, marginBottom: 3, borderBottom: '2px solid rgba(0, 0, 0, 0.08)', pb: 2.3, }} variant="h5" component="h1">{menu.shortF[+localStorage.getItem('atsLang') || 1]}</Typography>

                            <div className="short-cards">
                                {short?.slice().sort((a, b) => (+a.function_code) - (+b.function_code)).map((s) => {
                                    const label = translate?.find(t => t.code === s.function_code)?.[lang[+localStorage.getItem('atsLang') || 1]] || '';
                                    const isLocked = s.function_code === 10888;
                                    return (
                                        <Paper key={s.function_code} className="short-card" elevation={0}>
                                            <div className="short-card__label">
                                                  {label || shortFunction.phone[+localStorage.getItem('atsLang') || 1]}
                                            </div>
                                            <div className="short-card__code">
                                                {shortFunction?.[s.function_code][+localStorage.getItem('atsLang') || 1]}
                                            </div>
                                            <div className="short-card__actions">
                                                <span className="short-card__actions-item" style={{ color: "white", background: s.status || s.id || isLocked ? color : '#ce405f' }}>
                                                    {s.status || s.id ||  isLocked ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                                </span>
                                                {!isLocked && (
                                                    <span
                                                        onClick={() => {
                                                            if (s.function_code === 10999) navigate('/short_function/config', { state: { section: 'familiar' } });
                                                            else if (s.function_code === 100097) navigate('/short_function/config', { state: { section: 'voicemail' } });
                                                            else setEdit(s.function_code);
                                                        }}
                                                        className="edit"
                                                        title={sip.action[+localStorage.getItem('atsLang') || 1]}
                                                    >
                                                        <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 20 }} />
                                                    </span>
                                                )}
                                            </div>
                                        </Paper>
                                    )
                                })}



                                {/* <ShortInfoCard
                                    label={shortFunction.musicHold?.[+localStorage.getItem('atsLang') || 1] || 'Music Hold'}
                                    description={shortFunction.musicHoldDescription?.[+localStorage.getItem('atsLang') || 1] || 'Manage music hold files'}
                                    onEdit={() => navigate('/short_function/music_hold')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: musicHoldFiles.length ? color : '#ce405f'
                                        }}
                                    >
                                        {musicHoldFiles.length ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard> */}
                                <ShortInfoCard
                                    label={shortFunction.musicHold?.[+localStorage.getItem('atsLang') || 1] || 'Music Hold'}
                                    description={shortFunction.musicHoldDescription?.[+localStorage.getItem('atsLang') || 1] || 'Manage music hold files'}
                                    onEdit={() => navigate('/short_function/music_hold')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: musicHoldFiles.length ? color : '#ce405f'
                                        }}
                                    >
                                        {musicHoldFiles.length ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={shortFunction.preCall?.[+localStorage.getItem('atsLang') || 1] || 'Pre-Call Announcement'}
                                    description={shortFunction.preCallDesc?.[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/short_function/pre_call_announcement')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: preCallAnnouncement ? color : '#ce405f'
                                        }}
                                    >
                                        {preCallAnnouncement ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={shortFunction.callback?.[+localStorage.getItem('atsLang') || 1] || 'Callback'}
                                    description={shortFunction.callbackDesc?.[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/short_function/callback')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: callbackActive ? color : '#ce405f'
                                        }}
                                    >
                                        {callbackActive ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={menu.autoCall1[+localStorage.getItem('atsLang') || 1]}
                                    description={moneyT.autoCallDescription[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/auto_call_list')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span />
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={menu.autoCall2[+localStorage.getItem('atsLang') || 1]}
                                    description={moneyT.groupCallDescription[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/group_call_list')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span />
                                </ShortInfoCard>

                            </div>
                        </>

                    )}

                    {process.env.REACT_APP_SERVER !== 'Beeline' && (
                        <>
                            <SipOperators
                                operatorLabel={operatorLabel}
                                operatorCountLabel={operatorCountLabel}
                                operatorCounts={operatorCounts}
                            />
                        </>
                    )}
                    {process.env.REACT_APP_SERVER !== 'Beeline' && (
                        <>
                            <OpenAi />
                            <BlockedComponent />
                            <Telecomunication />
                            {hasReportView(employeeData) ? (
                            <>
                            <h3 style={{ margin: '20px 20px' }}>{shortFunction.reports?.[+localStorage.getItem('atsLang') || 1] || 'Reports'}</h3>
                            <div className="short-cards">
                                <ShortInfoCard
                                    label={shortFunction.operator_report?.[+localStorage.getItem('atsLang') || 1] || 'Employee Report'}
                                    description={shortFunction.operator_report_description?.[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/operator_report')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span />
                                </ShortInfoCard>
                            </div>
                            </>
                            ) : null}
                            <h3 style={{ margin: '20px 20px' }}>{shortFunction.otherIntegrations?.[+localStorage.getItem('atsLang') || 1] || 'External Integrations'}</h3>

                            <div className="short-cards">
                                <ShortInfoCard
                                    label={shortFunction.clickToCall[+localStorage.getItem('atsLang') || 1]}
                                    description={shortFunction.clickToCallDescription[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/short_function/widget')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: clickToCallIps.length ? color : '#ce405f'
                                        }}
                                    >
                                        {clickToCallIps.length ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={shortFunction.callCenter?.[+localStorage.getItem('atsLang') || 1] || 'Call Center'}
                                    description={shortFunction.callCenterDescription?.[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/short_function/call_center')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span
                                        className="short-card__actions-item"
                                        style={{
                                            padding: '2px 12px',
                                            color: 'white',
                                            background: callCenter?.member ? color : '#ce405f'
                                        }}
                                    >
                                        {callCenter?.member ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                    </span>
                                </ShortInfoCard>
                                <ShortInfoCard
                                    label={menu.provide[+localStorage.getItem('atsLang') || 1]}
                                    description={menu.provider_description[+localStorage.getItem('atsLang') || 1]}
                                    onEdit={() => navigate('/sip_providers')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span />
                                </ShortInfoCard>
                                {(userData.id === 10 || userData.id === 3888) && <ShortInfoCard
                                    label="SMS providing"
                                    description="Select recipients and send them an SMS message"
                                    onEdit={() => navigate('/short_function/sms_providing')}
                                    editTitle={sip.action[+localStorage.getItem('atsLang') || 1]}
                                >
                                    <span />
                                </ShortInfoCard>}

                            </div>
                            {edit ? <EditShortFunction have={have} all={short} open={edit} edit={edit} setOpen={setEdit} /> : null}
                        </>
                    )}
                </div>
            </Wrapper>
        </>

    );
}

export default ShortFunction;
